import request from './financeRequest'

export const reportApi = {
  monthlyDetail: (month) =>
    request.get('/finance/reports/monthly-detail', { params: { month } }),
  report: (type, params) => request.get(`/finance/reports/${type}`, { params }),
  branchSettlements: (params) =>
    request.get('/finance/settlements/branches', { params }),
  companySettlements: (params) =>
    request.get('/finance/settlements/company', { params }),
  export: (type, params) =>
    request.get(`/finance/exports/${type}`, {
      params,
      responseType: 'blob',
    }),
}
